module.exports = __webpack_public_path__ + "media/components/home/creator-community/img/vadosloginov-avatar-0658b9d07e8183ad394c02dd25f09b12.jpg";